<template lang="html">
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">{{store.name}}</h4>
      <p class="category">{{store.address}}</p>
    </div>
    <vue-tabs class="card-content">
      <v-tab title="Home">
        Larger, yet dramatically thinner. More powerful, but remarkably power efficient. With a smooth metal surface that seamlessly meets the new Retina HD display.
      </v-tab>
      <v-tab title="Profile">Here is your profile.</v-tab>
      <v-tab title="Messages">Here are your messages.</v-tab>
    </vue-tabs>
  </div>
</template>

<script>
export default {
  props: {
    store: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/Store/Home.vue